// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ju-0";
export var animationContainer = "_ju-1";
export var itemPrice = "_ju-a";
export var itemizedContent = "_ju-9";
export var itemizedHeader = "_ju-7";
export var itemizedRow = "_ju-8";
export var itemizedSection = "_ju-6";
export var modalContent = "_ju-2";
export var orderName = "_ju-3";
export var refundOption = "_ju-4";
export var refundOptionsContainer = "_ju-5";
export var shippingLabel = "_ju-b";
export var totalRow = "_ju-c";